var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencilWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6965 1.70934C13.6027 0.630491 11.8382 0.639418 10.7554 1.72927L1.9779 10.5639C1.56598 10.9785 1.29559 11.5118 1.20511 12.0882L0.620692 15.8108C0.489878 16.6441 1.22198 17.3575 2.05519 17.2088L5.75057 16.5491C6.3157 16.4483 6.83578 16.1759 7.23969 15.7694L16.0251 6.92673C17.1079 5.83688 17.099 4.0788 16.0051 2.99995L14.6965 1.70934ZM12.2739 3.22698C12.5265 2.97272 12.9382 2.97064 13.1933 3.22233L14.5019 4.51294C14.7571 4.76463 14.7592 5.17477 14.5066 5.42903L5.72115 14.2717C5.62692 14.3665 5.50559 14.4301 5.37375 14.4536L2.92792 14.8902L3.31615 12.4172C3.33726 12.2828 3.40034 12.1583 3.49644 12.0616L12.2739 3.22698Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilWhite);
export default __webpack_public_path__ + "static/media/pencil-white.206f60c7e6130ad083b44be508cd0379.svg";
export { ForwardRef as ReactComponent };